import InformationTab from './InformationTab';

export default InformationTab;
